import React, { FC } from 'react';
import cx from 'clsx';

import { isColorLight } from 'utils/Color';
import { ReactComponent as Logo } from './images/defaultLogo.svg';
import { HEADER_TEST_IDS } from './const';

import styles from './styles.module.scss';

type HeaderProps = {
  merchantName?: string;
  merchantLogo?: string;
  customHeaderColor?: string;
  className?: string;
  isInvoiceMode?: boolean;
  logoSize?: string;
};

const Header: FC<HeaderProps> = ({ customHeaderColor, isInvoiceMode = true, merchantName, merchantLogo, className, logoSize }) => (
  <header
    data-testid={HEADER_TEST_IDS.root}
    className={cx(styles.header, className, { [styles.noLogo]: !merchantLogo && !isInvoiceMode })}
    {...(!isInvoiceMode && { style: { backgroundColor: customHeaderColor } })}
  >
    <div className={styles.container}>
      <span
        className={cx(styles.logo, { [styles.logoHide]: !isInvoiceMode && !merchantLogo })}
        {...(!isInvoiceMode && logoSize && { style: { width: `${logoSize}px`, height: `${logoSize}px` } })}
      >
        {!isInvoiceMode && merchantLogo && (
          <img data-testid={HEADER_TEST_IDS.merchantLogo} src={merchantLogo} alt="" />
        )}

        {isInvoiceMode && (merchantLogo
          ? <img data-testid={HEADER_TEST_IDS.merchantLogo} src={merchantLogo} alt="" />
          : <Logo data-testid={HEADER_TEST_IDS.defaultLogo} />
        )}
      </span>
      {merchantName &&
        <h1 data-testid={HEADER_TEST_IDS.merchantName} className={cx(
          styles.merchantName,
          { [styles.merchantNameWhite]: !isInvoiceMode && customHeaderColor && !isColorLight(customHeaderColor) }
        )}>
          {merchantName}
        </h1>
      }
    </div>
  </header>
);

export { Header };
